import { request } from '../../utils/axios';

const pcPrefix = '/pcData';
const appPrefix = '/chartApp';

// ==================== 项目管理 ====================
export const getProjectList = async (params) => {
  return request.get(`${pcPrefix}/checkProject/list`, { params });
};
export const addProject = async (data) => {
  return request.post(`${pcPrefix}/checkProject/add`, data);
};
export const editProject = async (data) => {
  return request.post(`${pcPrefix}/checkProject/edit`, data);
};
export const deleteProject = async (params) => {
  return request.delete(`${pcPrefix}/checkProject/delete`, { params });
};
export const invalidProject = async (data) => {
  return request.post(`${pcPrefix}/checkProject/invalid`, data);
};
export const getProjectDetail = async (params) => {
  return request.get(`${pcPrefix}/checkProject/view`, { params });
};
// 项目检测事项（id: 项目id, projectCode: 检测报告编号）
export const getProcessViewList = async (params) => {
  return request.get(`${pcPrefix}/process/viewList`, { params });
};
// 项目检测事项步骤（processId: 检测事项id）
export const getStepViewList = async (params) => {
  return request.get(`${pcPrefix}/data/step/viewList`, { params });
};
// 检测步骤图片（stepId: 步骤id）
export const getStepViewImages = async (params) => {
  return request.get(`${pcPrefix}/data/step/viewStepImages`, { params });
};
export const uploadReportInfo = async (data) => {
  return request.post(`${pcPrefix}/checkProject/generateReport`, data);
};

// ==================== 报告查看 ====================
export const getViewReport = async (params) => {
  return request.get(`${appPrefix}/project/qrView/${params.reportId}`);
};
